// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';
import styles from 'components/InputForm.scss';

/**
 *  Input React presentational component.
 * @return {object} -
 */
export default class InputForm extends Component<*> {
  /**
   *  Props implementation.
   */
  static propTypes = {
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onTextChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]),
    checked: PropTypes.bool,
    type: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string,
    hasAutoFocus: PropTypes.bool,
    onChange: PropTypes.func,
    additionalOnChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  /**
   *  Default Props implementation.
   */
  static defaultProps = {
    type: 'text',
    required: false
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const {
      placeholder,
      extendStyle,
      hasAutoFocus,
      value,
      name,
      onChange,
      onBlur,
      onFocus,
      type,
      required
    } = this.props;
    let checked = false;
    if (type === 'checkbox' || type === 'radio') {
      checked = this.props.checked || false;
    }
    const { classInput } = styles;

    return (
      <input
        className={classNames(extendStyle, classInput)}
        placeholder={placeholder}
        value={value}
        name={name}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        autoFocus={hasAutoFocus}
        required={required}
        checked={checked}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Common/InputForm/index.js